import { AlertColor, Snackbar } from "@mui/material";
import { useEffect, forwardRef, useState } from "react";
import MuiAlert, { AlertProps } from "@mui/material/Alert";

const Alert = forwardRef<HTMLDivElement, AlertProps>(
  function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  },
);

let lastMsg = "";

export default function SnackMessage() {
  const [open, setOpen] = useState(false);
  const [alert, setAlert] = useState<{ type: AlertColor; message: string }>({
    type: "success",
    message: "Successful!",
  });

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === "clickaway") {
      return;
    }
    lastMsg = "";
    setOpen(false);
  };

  useEffect(() => {
    window.webApp = window.webApp || {};
    window.webApp.showMessage = (type, message) => {
      if (lastMsg !== message) {
        setOpen(true);
        setAlert({ type, message });
      }
    };
  }, []);

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <Alert onClose={handleClose} severity={alert.type} sx={{ width: "100%" }}>
        {alert.message}
      </Alert>
    </Snackbar>
  );
}
